import angular from 'angular';
import uiRouter from 'angular-ui-router';
import FleetComponent from './fleet.component';

const FleetModule = angular
  .module('Fleet', [uiRouter])

  .config([
    '$stateProvider',
    $stateProvider => {
      $stateProvider
        .state('newFleet', {
          url: '/fleets/new',
          component: 'fleet',
          parent: 'main',
          data: {
            permissions: {
              only: ['ADMIN'],
              redirectTo: 'home'
            }
          },
          resolve: {}
        })
        .state('editFleet', {
          url: '/fleets/:id',
          component: 'fleet',
          parent: 'main',
          data: {
            permissions: {
              only: ['ADMIN'],
              redirectTo: 'home'
            }
          },
          resolve: {
            fleet: [
              'FleetsService',
              '$stateParams',
              (FleetsService, $stateParams) => {
                return FleetsService.findById($stateParams.id);
              }
            ]
          }
        });
    }
  ])
  .component('fleet', FleetComponent).name;

export default FleetModule;
